<template>
    <div class="companyshow">
        <el-breadcrumb class="Breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/companyShow' }">企业秀/职播</el-breadcrumb-item>
            <el-breadcrumb-item>预览播放器</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="prism-player" id="J_prismPlayer"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            url: this.$route.query.url
        }
    },
    mounted() {
        this.openPlayer();
    },
    methods: {
        openPlayer() {
            new Aliplayer({
                id: "J_prismPlayer",
                height: '750px',
                autoplay: true,
                source: this.url
            }, function (player) {
                console.log('播放器创建成功')
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/company/CompanyShow/Player.vue